export enum SignTypesEnum {
  Manual = 'Manual',
  Docsign = 'Docusign',
}
